import * as React from "react";
type Props = {
  className?: string,
};
function SvgGlutenfree({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Gluten free"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0351 5.25226C20.0351 5.25226 14.231 10.38 20.0122 15.6368C20.0122 15.6368 25.5449 10.7901 20.0351 5.25226ZM12.9328 14.5319C12.9328 14.5319 12.1664 22.239 19.9805 22.1601C19.9805 22.1601 20.7387 14.8439 12.9328 14.5319ZM20.0196 22.1601C27.8336 22.239 27.0665 14.5319 27.0665 14.5319C19.2613 14.8439 20.0196 22.1601 20.0196 22.1601ZM12.9328 22.7723C12.9328 22.7723 12.1664 30.4793 19.9805 30.3997C19.9805 30.3997 20.7387 23.0843 12.9328 22.7723ZM19.9997 15.6368V35.0074V15.6368ZM20.0196 30.3997C27.8336 30.4793 27.0665 22.7723 27.0665 22.7723C19.2613 23.0843 20.0196 30.3997 20.0196 30.3997ZM18.2966 22.0391L16.8398 23.785L18.2966 22.0391ZM8.18123 34.1614L13.874 27.3387L8.18123 34.1614ZM24.08 15.1065L31.8188 5.83274L24.08 15.1065ZM19.9997 38.5714C30.2566 38.5714 38.5714 30.2566 38.5714 20.0004C38.5714 14.5857 36.2539 9.71321 32.5579 6.31808C29.252 3.28215 24.8427 1.42859 19.9997 1.42859C9.74345 1.42859 1.42859 9.74345 1.42859 20.0004C1.42859 30.2566 9.74345 38.5714 19.9997 38.5714Z"
        stroke="currentColor"
      />
    </svg>
  );
}
export default SvgGlutenfree;
